/*
 * @Author: Niko_yu
 * @Date: 2022-02-20 16:33:16
 * @LastEditors: OBKoro1
 * @LastEditTime: 2022-02-25 13:48:44
 * @FilePath: /前端/src/request.js
 * @Description:
 *
 * Copyright (c) 2022 by 854013212@qq.com, All Rights Reserved.
 */
import axios from "axios";
import qs from "qs";
import { Toast } from "antd-mobile";


export const origin = "http://tsinghua-wechat-hq.oss-cn-beijing.aliyuncs.com/";


// 正式
export const debug = false;
export const Host = "http://gzh.api.tsinghua.site/api/";




// export const debug = true;
// 测试接口
// export const Host = "http://wechat.gzh.liangchezai.com/api/";

// 本地
// export const Host = "http://admin.gzh.com/api/";

/**
 * 请求
 * @param {*} url
 * @param {*} data
 * @param {*} res
 * @param {*} err
 */
export function request(url, data, res, err) {
  if (url !== "index/auth") {
    // data["token"] = localStorage.getItem("token");
    data["uid"] = localStorage.getItem("openid");
    // data["uid"] = "o3KXx5lSukpaX5Lwn_JRTiW5R_hk";
  }

  axios
    .post(Host + url, qs.stringify(data))
    .then(function (response) {
      res.bind(this)(response);
    })
    .catch(function (error) {
      // alert(JSON.stringify(error))
      if (error.response.status === 405) {
        console.log(error.response);
        Toast.fail("请重新打开微官网");
        // setTimeout(() => {
        //   let base_url = window.location.protocol + "//" + window.location.host + "" + window.location.pathname
        //   let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxdc8058c0b71a3b35&redirect_uri=${encodeURIComponent(
        //     base_url
        //   )}&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect`;
        //   console.log("没有token 跳转授权URI");

        //   window.location.href = url;
        // }, 15000);
      } else {
        err ? err.bind(this)(error) : console.log("接口错误：" + error);
      }
    });
}




// WEBPACK FOOTER //
// ./src/request.js